var PestControlUtils = function() {
    return {
        unitType: function(pest_property_type, pest_type) {
            return PEST_CONTROL[pest_property_type][pest_type];
        },
    };
}();

export default PestControlUtils;
